import * as React from "react";
import "../../css/ServerError.scss";

interface IProps {
  children: React.ReactNode;
}
interface IState {
  hasError: boolean;
}

//Safety net for uncaught render/lifecycle exceptions in routed page content - most commonly caused
//by a page assuming an API call succeeded and reading a field off an error response (e.g. an
//expired/invalid token producing a 401) without checking for it first. Without this, React just
//unmounts the whole app to a blank screen. This shows a recoverable message instead.
class ErrorBoundary extends React.Component<IProps, IState> {
  public state: IState = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, info: any) {
    console.error("Unhandled UI error:", error, info);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="s-error-container">
          <div className="s-error-icon">X</div>
          <div className="s-error-content">
            <div>Something went wrong loading this page.</div>
            <div>
              <span>Your session may have expired. </span>
              <a href="/loginstart">Log out and log back in</a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
